<template>
  <div class="bg-white border border-section_border border-b-0 rounded">
    <ul class="genre-place-list">
      <li v-for="place in places" v-bind:key="place.id" class="border-b">
        <genre-place @openPlace="$emit('openPlace', place)" :place="place" />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GenrePlace from './GenrePlace'

export default {
  components: {
    GenrePlace
  },
  props: {
    genre: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      places: []
    }
  },
  mounted() {
    this.places = this.$store.getters['places/getPlacesByGenre'](this.genre)
    this.places.sort((a, b) => {
      return (this.getDistance(this.center.lat, this.center.lng, a.location.latitude, a.location.longitude) < this.getDistance(this.center.lat, this.center.lng, b.location.latitude, b.location.longitude) ? -1 : 1);
    });
  },
  methods: {
    getDistance: function (lat1, lng1, lat2, lng2) {
      lat1 *= Math.PI / 180;
      lng1 *= Math.PI / 180;
      lat2 *= Math.PI / 180;
      lng2 *= Math.PI / 180;
      const d = 6371 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2))
      return d;
    }
  },
  computed: {
    ...mapGetters({
      center: 'map/getCenter'
    })
  },
  watch: {
    genre: function (val) {
      this.places = this.$store.getters['places/getPlacesByGenre'](val)
      this.places.sort((a, b) => {
        return (this.getDistance(this.center.lat, this.center.lng, a.location.latitude, a.location.longitude) < this.getDistance(this.center.lat, this.center.lng, b.location.latitude, b.location.longitude) ? -1 : 1);
      });
    }
  }
}
</script>
